var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInjIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000113341662969722904690000001106436462312227999_);}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 441.1,
    cy: 441.1,
    r: 440.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.5,
    y1: 848.0258,
    x2: 881.7271,
    y2: 848.0258,
    gradientTransform: "matrix(1 0 0 1 0 -368.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0082FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F2FE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3,152.8c5.5-6.8,11.2-13.4,17-20c0.2-0.2,0.9-0.4,1.1-0.7c0.4-0.7,1.3-1.1,2-1.8l0.4-0.7 c4-3.7,8.4-7.7,13.2-11.5c17.6-13.2,35.7-23.4,54.9-30.2c61.7-21.6,130.2-8.4,184,42.5c75.1,70.3,68.3,183.7,8.4,259.1 C312.4,502,182.4,658.7,362.4,799c32.4,25.3,56.4,46,158.4,75.6c-66.8,12.3-128.7,8.4-197.4-9c-48.7-27.5-125.4-86.4-151.4-165.9 c-39.4-120.5,69.4-300.9,121.8-370.3c72-96.1-44.5-200-130.6-83.9C118.8,306,40.1,477.1,67.4,604.2 c15.9,72,37.2,124.5,121.6,196.7c-15.6-9.3-30.8-19.6-45.6-31.5C-52.4,586.8-29.7,304.4,107.3,152.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043448511828594940700000006756964663487172530_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.4684,
    y1: 770.4098,
    x2: 881.6954,
    y2: 770.4098,
    gradientTransform: "matrix(1 0 0 1 0 -368.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0082FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F2FE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043448511828594940700000006756964663487172530_)"
    },
    d: "M774.8,729.6c-5.5,6.8-11.2,13.4-17,20 c-0.2,0.2-0.9,0.4-1.1,0.7c-0.4,0.7-1.3,1.1-2,1.8l-0.4,0.7c-4,3.7-8.4,7.7-13.2,11.2c-17.6,13.2-35.7,23.4-54.9,30.2 c-61.7,21.6-130.2,8.4-184-42.5c-75.1-70.3-68.3-183.7-8.4-259.1c75.8-112.4,205.8-269,25.8-409.3c-32.4-25.3-56.4-46-158.4-75.6 c66.8-12.3,128.7-8.4,197.4,9c48.7,27.5,125.4,86.4,151.4,165.9c39.4,120.5-69.4,300.9-121.8,370.3c-72,96.1,44.5,200,130.6,83.9 c44.9-60.6,123.6-231.8,96.3-358.9c-15.9-72-37.2-124.5-121.6-196.7c15.6,9.3,30.8,19.6,45.6,31.5 C934.6,295.6,911.9,578,774.8,729.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjIcon);
export default __webpack_public_path__ + "static/media/inj_icon.3fd89e27d8ededafbe784d3d8f709081.svg";
export { ForwardRef as ReactComponent };